export enum TasksNotes {
  Task = 0,
  Note = 1,
}
